import {
  interpolate,
  SAMPLE_VALUES,
  SampleValue,
  VariantText,
} from './copyModel';
import { Bubble, Caption, Label, Phone, Segment } from './styles';

export type PreviewMode = 'sample' | 'longest';

type Props = {
  text: VariantText;
  mode: PreviewMode;
  onMode: (mode: PreviewMode) => void;
  longestValues: Record<string, SampleValue>;
  emailFooter: string;
};

const CopyPreview = ({
  text,
  mode,
  onMode,
  longestValues,
  emailFooter,
}: Props) => {
  const values = mode === 'longest' ? longestValues : SAMPLE_VALUES;
  const show = (field: string) => interpolate(text[field] ?? '', values);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 8,
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Label>Live preview</Label>
        <Segment role="group" aria-label="Preview values">
          <button
            type="button"
            aria-pressed={mode === 'sample'}
            onClick={() => onMode('sample')}
          >
            Sample values
          </button>
          <button
            type="button"
            aria-pressed={mode === 'longest'}
            onClick={() => onMode('longest')}
          >
            Longest values
          </button>
        </Segment>
      </div>
      <div
        data-testid="copyPreview"
        style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
      >
        {text.sms !== undefined && (
          <Phone>
            <Caption>SMS from GravyWork</Caption>
            <Bubble>{show('sms')}</Bubble>
          </Phone>
        )}
        {text.push_body !== undefined && (
          <Phone>
            <div
              style={{
                backgroundColor: 'rgba(255,255,255,.92)',
                borderRadius: 12,
                padding: '10px 12px',
                display: 'flex',
                gap: 10,
              }}
            >
              <div
                aria-hidden="true"
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 7,
                  backgroundColor: '#1E8E3E',
                  color: '#FFFFFF',
                  fontWeight: 800,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: 'none',
                }}
              >
                G
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  minWidth: 0,
                }}
              >
                <strong style={{ fontSize: 13 }}>
                  {text.push_title !== undefined
                    ? show('push_title')
                    : 'GravyWork'}
                </strong>
                <span style={{ fontSize: 13, lineHeight: 1.35 }}>
                  {show('push_body')}
                </span>
              </div>
            </div>
          </Phone>
        )}
        {text.body !== undefined && (
          <div
            style={{
              border: '1px solid #DADADA',
              borderRadius: 8,
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                backgroundColor: '#FAFAFA',
                padding: '10px 12px',
                borderBottom: '1px solid #EDEDED',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
              }}
            >
              <strong style={{ fontSize: 13 }}>{show('subject_a')}</strong>
              <Caption>{show('preview')}</Caption>
            </div>
            <div
              style={{
                padding: 16,
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 700 }}>
                {show('headline')}
              </div>
              <div style={{ whiteSpace: 'pre-line', lineHeight: 1.5 }}>
                {show('body')}
              </div>
              <span
                style={{
                  alignSelf: 'flex-start',
                  backgroundColor: '#1E8E3E',
                  color: '#FFFFFF',
                  fontWeight: 600,
                  borderRadius: 6,
                  padding: '9px 16px',
                }}
              >
                {show('button')}
              </span>
              <Caption
                style={{ borderTop: '1px solid #EDEDED', paddingTop: 10 }}
              >
                {emailFooter}
              </Caption>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CopyPreview;
